// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"dce95883","195":"ffea5570","437":"b7302f59","440":"8b897889","453":"ec36abf3","454":"e9d7e45f","458":"ed9bf0c7","688":"c4470f77","690":"ab2a7909","985":"1c8203d1"}[chunkId] + ".chunk.js";
};